import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const statusStyles: Record<string, string> = {
  active: 'bg-green-100 text-green-800 border-green-200',
  invited: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  deactivated: 'bg-red-100 text-red-800 border-red-200',
}

interface StatusBadgeProps {
  status: string
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(statusStyles[status] ?? 'bg-gray-100 text-gray-800 border-gray-200')}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>
  )
}
